import { HomeSearch } from "../MarketPlace/MarketPlaceElements";
import { LupaBuscar } from "../svg/LupaBuscar";


import { user } from "../../store/modules/UserStore";

import { Dispatch, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCISAll,
  marketPlace,
  setCISerialSelected,
  setCiTableInformation,
  setShowCiStore,
  setShowCiTable,
} from "../../store/modules/MarketPlaceStore";

import { SubmitButtons } from "../CreateRequestPage/createRequestElements";

import { toast } from "react-toastify";

import  {ciSerial} from '../../interfaces/AssetInformation'
import { useTranslation } from "react-i18next";
import TranslatableText from "../Multilanguage/TranslatableText";

const CisTable = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const userStore = useSelector(user);

  const { t } = useTranslation()

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const marketStore = useSelector(marketPlace);
  const [arregloJson, setArregloJson] = useState<
    Array<{ ciId: string, ciName: string; usedBy: string; location: string }>
  >([]);
  const [arraySerialCi, setArraySerialCI] = useState<ciSerial[]>([]);
  const [ciiOrName, setCiiOrName] = useState<string>("");
  const [typeCi, setTypeCi] = useState<number>();
  const defaultUserLogin = userStore.username;

  const showErrorMessage = (message: string): void => {
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleCheckboxChange = (
    id: string,
    ciName: string,
    usedBy: string,
    location: string
  ) => {
    const isSelected = selectedRows.includes(id);
    if (isSelected) {
      // Si la fila ya está seleccionada, quítala de la lista
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
      const nuevoArreglo = arregloJson.filter(
        (rowName) => rowName.ciName !== ciName
      );
      setArregloJson(nuevoArreglo);
    } else {
      // Si la fila no está seleccionada, agrégala a la lista
      setSelectedRows([...selectedRows, id]);
      setArregloJson([
        ...arregloJson,
        { ciId: id, ciName: ciName, usedBy: usedBy, location: location },
      ]);

      const newSerial: ciSerial = { CIID: id };

      setArraySerialCI((prevArraySerialCI) => [
        ...prevArraySerialCI,
        newSerial,
      ]);
    }
  };

  const addCiForId = () => {
    if (selectedRows.length > 0) {
      dispatch(setCISerialSelected(arraySerialCi));
      dispatch(setCiTableInformation(arregloJson));
      dispatch(setShowCiTable(true));
      dispatch(setShowCiStore(false));
    } else {
      showErrorMessage(t("cis.select"));
    }
  };

  const cancelCi = () => {
    setArregloJson([]);
    setSelectedRows([]);
    dispatch(setShowCiStore(false));
  };

  const handleCISearch = (e: any) => {
    dispatch(getCISAll(e, typeCi, defaultUserLogin));
  }

  const TABLE_HEAD = ["", t("cis.name"), t("cis.usedBy"), t("cis.location"), t("cis.serial"), "CI"];

  return (
    <>
      <div className="modal h-screen w-full fixed left-0 top-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded shadow-lg ">
          <div className="border-b px-4 py-2 flex justify-between items-center">
            <h3 className="font-semibold text-lg">{t("cis.associateAsset")}</h3>
          </div>

          <div className="py-5 px-5">
            <HomeSearch
              type="search"
              name="search"
              placeholder={t("cis.searchAsset")}
              className="bg-inherit h-10 px-5 pr-10 rounded-full text-sm focus:outline-none w-full"
              onChange={(e: any) => handleCISearch(e.target.value)}
            />
            <button type="submit" className="absolute right-4 top-3">
              <LupaBuscar />
              {""}
            </button>
          </div>
          <div className="overflow-y-auto px-5 max-h-64">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 px-5 table-auto ">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 px-5">
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th key={head} className="px-6 py-3">
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {marketStore.cisInformation.map(
                  ({ CIName, UsedBy, Location, CIID, typeCi }, index) => {
                    const isLast =
                      index === marketStore.cisInformation.length - 1;

                    return (
                      <tr
                        key={CIID}
                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                      >
                        <td
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(CIID)}
                            onChange={() =>
                              handleCheckboxChange(
                                CIID,
                                CIName,
                                UsedBy,
                                Location
                              )
                            }
                          />
                        </td>
                        <td
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <TranslatableText text={CIName} />
                        </td>
                        <td
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {UsedBy}
                        </td>
                        <td
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <TranslatableText text={Location} />
                        </td>
                        <td
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {CIID}
                        </td>
                        <td
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <TranslatableText text={typeCi} />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end items-center w-100 border-t p-3">
            <SubmitButtons onClick={cancelCi}>{t("cancelButton")}</SubmitButtons>
            <SubmitButtons
              bg="#3948ff"
              color="white"
              className="mx-4"
              onClick={addCiForId}
            >
              {t("addButton")}
            </SubmitButtons>
          </div>
        </div>
      </div>
    </>
  );
};

export default CisTable;
